import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { SafeArea } from '@capacitor-community/safe-area';
import { SplashScreen } from '@capacitor/splash-screen';
import { IonContent } from '@ionic/angular/standalone';
import { interval, take } from 'rxjs';
@Component({
  selector: 'app-initial',
  templateUrl: './initial.page.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonContent]
})
export class InitialPage implements OnDestroy {
  ngOnDestroy(): void {
    SplashScreen.hide().then(() => {
      interval(200).pipe(take(10)).subscribe(() => {
        SafeArea.enable({
          config: {
            customColorsForSystemBars: true,
            statusBarColor: '#ffffff',
            statusBarContent: 'dark',
            navigationBarColor: '#ffffff',
            navigationBarContent: 'dark'
          }
        });
      });
    });
  }
}
